
import React from 'react';
import { format } from 'date-fns';
import { TimeSlot } from '@/utils/timeSlotUtils';
import { getTimezoneDisplayName } from '@/utils/timeZoneUtils';
import { CalendarDays, Clock, Globe } from 'lucide-react';

interface BookingSummaryProps {
  selectedDate: Date;
  selectedTimeSlot: TimeSlot;
  timezone: string;
}

const BookingSummary: React.FC<BookingSummaryProps> = ({
  selectedDate,
  selectedTimeSlot,
  timezone
}) => {
  return (
    <div className="bg-accent/30 rounded-lg p-5 border border-border">
      <h3 className="font-medium mb-3 text-lg">Appointment Summary</h3>
      
      <div className="space-y-3">
        <div className="flex items-start">
          <CalendarDays className="h-5 w-5 mr-3 text-primary mt-0.5" />
          <div>
            <p className="font-medium text-sm">Date</p>
            <p className="text-muted-foreground">
              {format(selectedDate, "EEEE, MMMM d, yyyy")}
            </p>
          </div>
        </div>
        
        <div className="flex items-start">
          <Clock className="h-5 w-5 mr-3 text-primary mt-0.5" />
          <div>
            <p className="font-medium text-sm">Time</p>
            <p className="text-muted-foreground">
              {format(selectedTimeSlot.startTime, "h:mm a")} - {format(selectedTimeSlot.endTime, "h:mm a")}
            </p>
          </div>
        </div>
        
        <div className="flex items-start">
          <Globe className="h-5 w-5 mr-3 text-primary mt-0.5" />
          <div>
            <p className="font-medium text-sm">Timezone</p>
            <p className="text-muted-foreground">
              {getTimezoneDisplayName(timezone)}
            </p>
          </div>
        </div>
      </div>
      
      <div className="mt-4 text-xs text-muted-foreground border-t border-border pt-3">
        All times are shown in your selected timezone.
      </div>
    </div>
  );
};

export default BookingSummary;
